<template>
  <div>
    <v-row>
      <v-col>
        <v-autocomplete
          item-value="key"
          item-text="value"
          :items="min"
          :label="'حداقل ' + label"
          dense
          outlined
          prepend-inner-icon="fa fa-pencil-alt"
          @input="getVal($event, name, 'min')"
          clear-icon="mdi-close-circle-outline"
          :placeholder="'جستجوی مقدار ' + label"
          clearable
          v-if="others === false"
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @mousedown.prevent @click="others = true">
              <v-list-item-action>
                <p>واردکردن مقدار دلخواه</p>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-autocomplete>
        <v-text-field
          v-else
          :label="'حداقل ' + label"
          dense
          outlined
          prepend-inner-icon="fa fa-pencil-alt"
          @input="getVal($event, name, 'min')"
          clear-icon="mdi-close-circle-outline"
          clearable
          :placeholder="'وارد کردن مقدار ' + label"
          hint="مبلغ وارد شده توسط شما به تومان محاسبه میشود."
        ></v-text-field>
      </v-col>

      <v-col>
        <v-autocomplete
          item-value="key"
          item-text="value"
          :label="'حداکثر ' + label"
          :items="max"
          @input="getVal($event, name, 'max')"
          prepend-inner-icon="fa fa-pencil-alt"
          dense
          outlined
          :placeholder="'جستجوی مقدار ' + label"
          v-if="otherMax === false"
          clear-icon="mdi-close-circle-outline"
          clearable
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @mousedown.prevent @click="otherMax = true">
              <v-list-item-action>
                <p>واردکردن مقدار دلخواه</p>
              </v-list-item-action>
            </v-list-item>
            <!--                        <v-divider class="mt-0"></v-divider>-->
          </template>
        </v-autocomplete>
        <v-text-field
          v-else
          :label="'حداکثر ' + label"
          dense
          outlined
          prepend-inner-icon="fa fa-pencil-alt"
          clear-icon="mdi-close-circle-outline"
          @input="getVal($event, name, 'max')"
          :placeholder="'وارد کردن مقدار ' + label"
          clearable
          hint="مبلغ وارد شده توسط شما به تومان محاسبه میشود."
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Bus } from "@/main";

export default {
  name: "InDialogRangeField",
  props: {
    fields: {
      require: true,
      default: [],
    },
    label: {
      require: true,
    },
    name: {
      require: true,
    },
  },
  data() {
    return {
      others: false,
      otherMax: false,
      values: {
        min: null,
        max: null,
      },
    };
  },
  methods: {
    getVal(value, name, type) {
      this.values[type] = parseInt(value);
      this.values = Object.fromEntries(
        Object.entries(this.values).filter(([x, y]) => {
          return y != null && !isNaN(y);
        })
      );
    },
  },
  watch: {
    values: {
      deep: true,
      handler(value) {
        Bus.$emit("dialogRange", this.name, value);
      },
    },
  },
  computed: {
    min() {
      let items = [];

      this.fields.enum.forEach((item, index) => {
        items.push({
          key: item,
          value: this.fields.enumNames[index],
        });
      });

      return items;
    },
    max() {
      let items = [];

      this.fields.enum.forEach((item, index) => {
        items.push({
          key: item,
          value: this.fields.enumNames[index],
        });
      });

      return items;
    },
  },
};
</script>

<style scoped></style>
